<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="77.473" height="79.361" viewBox="0 0 77.473 79.361" ref="waiting">
    <g transform="translate(-963.398 318.751) rotate(-45)">
      <path class="a"
            d="M964.5,32.055a27.885,27.885,0,0,0-5.412-5.7,30.648,30.648,0,0,0-7.709-4.535,27.287,27.287,0,0,0-5.65-1.661,17.6,17.6,0,0,0-3.054-.24l-.574-.01c-1.287-.033-4.7.221-5.082.263a31.622,31.622,0,0,0-6.291,1.3c.345.067.691.14,1.036.219a20.708,20.708,0,0,1,2.153.658c.293.1.583.2.878.3l1.573.6c.065.021,2.181,1.009,2.181,1.009.292.163.6.324.9.487.685.368,1.4.746,2.078,1.182a31.516,31.516,0,0,1,6.506,5.533,21.949,21.949,0,0,1,3.334,4.729,24.712,24.712,0,0,1,1.648,4.117,22.68,22.68,0,0,1,.842,4.246,19.2,19.2,0,0,1-.167,5.617l-.165.844,0,0a23.11,23.11,0,0,1-.863,3.309,12.837,12.837,0,0,1-4.01,5.683c.255-.075.514-.134.765-.219a22.465,22.465,0,0,0,3.68-1.625,19.763,19.763,0,0,0,4.127-3.141,29.214,29.214,0,0,0,4.917-6.212c.368-.625.689-1.278,1.028-1.97q.232-.476.47-.95l.842-1.884.282-.909.2-.629c.077-.278.176-.589.269-.9a18.285,18.285,0,0,0,.522-1.93c.169-.884.3-1.807.42-2.7.073-.539.148-1.08.232-1.619a1.44,1.44,0,0,1,.036-.167,35.333,35.333,0,0,0-1.934-3.106"
            transform="translate(-33.368 462.376)"/>
      <path class="b" d="M947.021,31.339l.2-.626-.2.629v0Z" transform="translate(-15.631 473.935)"/>
      <path class="c"
            d="M931.045,49.87c.129.272.274.537.417.8.086.159.167.317.259.476.167.288.349.572.531.856.083.127.159.257.245.382q.413.611.877,1.2a19.679,19.679,0,0,0,3.86,3.739,34.93,34.93,0,0,0,4.155,2.642,29.286,29.286,0,0,0,8.5,2.93,44,44,0,0,0,7.225.641s.957,0,1.89-.054l.008,0a27.933,27.933,0,0,0,5.441-5.564,30.686,30.686,0,0,0,4.261-7.862,27.466,27.466,0,0,0,1.46-5.706,30.437,30.437,0,0,0,.342-4.332,43.949,43.949,0,0,0-.416-5.172,27.36,27.36,0,0,0-.786-3.586,20.471,20.471,0,0,0-.883-2.519c-.083.566-.175,1.138-.284,1.706-.144.754-.32,1.376-.451,1.867-.167.62-.347,1.278-.43,1.575l-.359,1.1s-.2.512-.554,1.3-.833,1.635-.984,1.943c-.345.7-.7,1.422-1.111,2.124a31.655,31.655,0,0,1-5.3,6.7,22.041,22.041,0,0,1-4.61,3.5,24.751,24.751,0,0,1-4.056,1.79,22.782,22.782,0,0,1-4.215.992,19.834,19.834,0,0,1-5.025.109c-.2-.023-.395-.048-.591-.077a28.058,28.058,0,0,1-4.19-.886,12.838,12.838,0,0,1-5.685-3.653c.071.171.142.345.219.516s.152.351.236.524"
            transform="translate(-33.522 471.468)"/>
      <path class="b" d="M930.931,39.134c-.084-.173-.159-.349-.236-.524.077.175.153.351.236.524"
            transform="translate(-33.056 482.384)"/>
      <path class="b" d="M931.265,39.721c-.09-.157-.171-.317-.257-.476.086.159.167.32.257.476"
            transform="translate(-32.72 483.064)"/>
      <path class="d"
            d="M939.27,29.6a20.713,20.713,0,0,0-6.005,3.3,25.052,25.052,0,0,0-4.61,4.616s-.2.213-.587.689a32.421,32.421,0,0,0-2.166,3.334,33.813,33.813,0,0,0-1.988,4.407c-.495,1.285-.88,2.632-1.293,4.129a10.767,10.767,0,0,0-.238,1.276c-.048.317-.192,1.094-.219,1.168a18.111,18.111,0,0,0,1.138,2.03c.66,1,1.349,1.993,2.039,2.979,0,0,1.531,1.953,1.613,2.039l1.147,1.345.9.827s.493.409.62.528a9.73,9.73,0,0,0,.746.633,38.816,38.816,0,0,0,4.831,3.16,32.313,32.313,0,0,0,5.886,2.392,28.629,28.629,0,0,0,5.635,1.028,31.265,31.265,0,0,0,5.669-.029,28.5,28.5,0,0,0,6.632-1.439l.464-.163a36.264,36.264,0,0,0,4.117-1.838c.41-.211.808-.445,1.21-.689a32.57,32.57,0,0,1-6.172-.564,31.574,31.574,0,0,1-9.159-3.16,37.127,37.127,0,0,1-4.426-2.816,22.531,22.531,0,0,1-7.636-10.011,23.456,23.456,0,0,1-1.535-8.71c.009-.524.031-1.051.075-1.581a14.162,14.162,0,0,1,2.124-6.318,11.748,11.748,0,0,1,2.788-3.05l-.029,0-.666.165a8.248,8.248,0,0,1-.9.32"
            transform="translate(-42.155 471.864)"/>
      <path class="e"
            d="M923.343,53.492a35.931,35.931,0,0,1,2.128-4.708,39.563,39.563,0,0,1,2.832-4.157l.082-.111a27.36,27.36,0,0,1,5.023-5.044,23.1,23.1,0,0,1,6.709-3.68l.3-.094a1.577,1.577,0,0,0,.263-.084l1.74-.455c.034-.006.276-.054.357-.063l0-.008c.4-.052.8-.111,1.207-.173a28.348,28.348,0,0,1,2.887-.33c.4-.019.808-.021,1.212-.013a23.216,23.216,0,0,1,4.023.451,17.628,17.628,0,0,1,4.6,1.466,13.331,13.331,0,0,1,5.529,5.028,21.213,21.213,0,0,0-.528-2.2,22.529,22.529,0,0,0-1.493-3.733,19.8,19.8,0,0,0-3-4.236,29.287,29.287,0,0,0-6.034-5.132h0c-.61-.389-1.249-.733-1.928-1.092-.313-.169-.627-.338-.938-.51,0,0-1.55-.756-1.753-.825-.144-.05-.453-.2-.453-.2l-1.168-.42c-.273-.086-.58-.192-.888-.3a18.9,18.9,0,0,0-1.913-.589c-.879-.2-1.8-.361-2.686-.516-.535-.094-1.072-.186-1.6-.288a1.508,1.508,0,0,1-.207-.054,27.328,27.328,0,0,0-6.55,4.34,40.055,40.055,0,0,0-3.254,3.3A24.772,24.772,0,0,0,925.43,32.3c-.6.971-1.109,1.988-1.65,3.064q-.288.576-.583,1.151a23.611,23.611,0,0,0-1.951,6.222,30.152,30.152,0,0,0-.491,4.505,32.972,32.972,0,0,0,.094,4.259,27.437,27.437,0,0,0,1.222,6.005c.4-1.427.777-2.728,1.272-4.01"
            transform="translate(-43.724 464.025)"/>
    </g>
  </svg>
</template>

<script>
import {onMounted} from "@vue/composition-api";

export default {
  name: "WaitingIndicator",
  setup(_, {refs}) {
    onMounted(() => {
      refs['waiting'].animate([
        {transform: 'rotate(0deg)'},
        {transform: 'rotate(360deg)'}
      ], {
        duration: 1000,
        iterations: Infinity
      });

    })
  }
}
</script>

<style scoped>

.a, .e {
  fill: #71908b;
}

.a {
  opacity: 0.299;
}

.b {
  fill: #3e4041;
}

.c {
  fill: rgba(113, 144, 139, 0.6);
  opacity: 0.301;
}

.d {
  fill: #57b98f;
}

.e {
  opacity: 0.297;
}
</style>
